import axios from 'axios'
import store from '@/store'
import router from "@/router";
import {toast} from "../class/Notification";
import {findObjectIndex} from "../class/Converter";

export const CrawlerTypes = {
    product: {
        'columns': [
            {label: 'قیمت', value: 'price'},
            {label: 'نام', value: 'name'},
            {label: 'ویژگی', value: 'feature'},
        ]
    },
    content: {
        'columns': [
            {label: 'تیتر', value: 'title'}
        ]
    },
}

export const crawlerPositionExtraOptions = {
    price: 'قیمت',
    offer: 'تخفیف',
    quantity: 'تعداد',
}


export default {
    namespaced: true,
    state: {
        crawlers: {},
    },
    mutations: {
        setCrawlers(state, crawlers) {
            state.crawlers = crawlers
        },
        deleteCrawler: (state, crawler) => {
            state.crawlers.splice(findObjectIndex(store.getters['Crawler/getCrawlers'], crawler), 1)
        },
    },
    actions: {
        getCrawlers({commit}, form) {
            axios.post(`crawler/item/crawlers`, form)
                .then(res => {
                    const data = res.data.data;
                    commit('setCrawlers', data)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        createCrawler({commit}, form) {
            axios.post('/crawler', form)
                .then(res => {
                    toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد.')
                    const crawlerForm = {
                        crawlerable_id: form.crawlerable_id,
                        crawlerable_type: 'product',
                    }
                    store.dispatch('Crawler/getCrawlers', crawlerForm)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        updateCrawler({commit}, form) {
            axios.put(`/crawler/${form.id}`, form)
                .then(res => {
                    toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد.')
                })
                .catch(error => {
                    console.log(error)
                })
        },
        deleteCrawler({commit}, crawler) {
            axios.delete(`crawler/${crawler.id}`)
                .then(res => {
                    commit('deleteCrawler', crawler)
                })
                .catch(error => {
                    console.log(error)
                })
        },
    },
    getters: {
        getCrawlers: state => state.crawlers,
    }
}